import { POST, GET } from "./utils";

// 60 second timeout for workflow creation (includes uploading frames to dataset)
const WORKFLOW_CREATION_TIMEOUT_MS = 60 * 1000;

export const createRapidWorkflow = async (data: any) => {
    return await POST("/api/workflow", data, { timeoutMs: WORKFLOW_CREATION_TIMEOUT_MS });
};

export const getRapidWorkflow = async (workflowUrl: string, workspaceId: string) => {
    return await GET(`/api/workflow/${workflowUrl}?workspaceId=${workspaceId}`);
};

export const getPublicRapidWorkflowBySlug = async (shareableSlug: string) => {
    return await GET(`/api/workflow/public/${shareableSlug}`);
};

export const getWorkflowToken = async (workflowId: string, workspaceId: string) => {
    return await GET(`/query/workflow/token?workflowId=${workflowId}&workspaceId=${workspaceId}`);
};

export const getPublicRapidData = async (rapidDataId: string) => {
    return await GET(`/api/rapiddata/public/${rapidDataId}`);
};

export const getWorkspaceRapidModels = async (workspaceId: string) => {
    return await GET(`/api/workspace/${workspaceId}/models`);
};

export const saveWorkflowFromTemplate = async (
    workspaceId: string,
    workflow: { name: string; url: string; template: string; config: string }
) => {
    return await POST("/query/workflow/save", { workspaceId, workflow });
};
